$(document).ready(function(){
    $("form").styleOptions();
});

$.fn.styleOptions = function()
{
  var setNum = 0;
  // run each one independently
  this.each(function() {

    var _this = this;

    _this.setNum = setNum;
    setNum++;


    $(_this).find(".ui-radio").remove();

     _this.radios = new Array();
     _this.radios = ($(_this).find("input[type=radio]"));


     _this.multiRadios = new Array();
     _this.multiRadios[0] = new Array();

     var currentGroup = $(_this.radios[0]).attr('name');


     var currentIndex = 0;
     var currentRadioIndex = 0;

    for(i = 0; i < _this.radios.length; i++){
         current = _this.radios[i];

         var currentLabel = $(_this).find("label[for="+$(current).attr('class')+"]");

         if(currentGroup == $(current).attr('name')){
             _this.multiRadios[currentIndex][currentRadioIndex] = current;

             $(current).after('<div class="ui-radio' + (($(current).is(':checked'))?" checked": "") + (($(current).attr('disabled') == "disabled")?" disabled": "") + '" rri="' + _this.setNum + '_' + currentRadioIndex + '" rgi="' + _this.setNum + '_' + currentIndex  + '"></div>');

             currentRadioIndex ++;

         } else {
             currentIndex ++;
             currentRadioIndex = 0;
             currentGroup = $(current).attr('name');

             _this.multiRadios[currentIndex] = new Array();
             _this.multiRadios[currentIndex][currentRadioIndex] = current;
             $(current).after('<div class="ui-radio' + (($(current).is(':checked'))?" checked": "") + (($(current).attr('disabled') == "disabled")?" disabled": "") + '" rri="' + _this.setNum + '_' + currentRadioIndex + '" rgi="' + _this.setNum + '_' + currentIndex  + '"></div>');

             currentRadioIndex ++;
         }



      //if a change is made to actual radio button (via labels)

      $(current).change(function(){


        var who = $(this).next(".ui-radio");
        //if the actual input box is checked
        var groupAttr = $(who).attr("rgi");
        // $(_this).find(".ui-radio[rgi=" + groupAttr + "]").prop("checked",false);
        $(".ui-radio[rgi=" + groupAttr + "]").removeClass('checked');

        $(who).addClass('checked');

      });

         $(current).hide();
         //$(currentLabel).hide();


    }



    $(_this).find(".ui-radio").click(function(){

         if($(this).hasClass('disabled')) return false;

         radioAttr = $(this).attr('rri');
         groupAttr = $(this).attr('rgi');

         radioName = radioAttr.split("_");
         groupName = groupAttr.split("_");

         for(var i=0; i<_this.multiRadios[groupName[1]].length; i++){
             $(_this.multiRadios[groupName[1]][i]).prop('checked',false);
         }

         $(".ui-radio[rgi=" + groupAttr + "]").removeClass('checked');
         $(this).addClass('checked');
         $(_this.multiRadios[groupName[1]][radioName[1]]).prop('checked',true);

    });





    $(_this).find(".ui-checkbox").remove();


    //create an array to hold the boxes
    _this.boxes = new Array();
    //put in all the boxes into array
    _this.boxes = ($(_this).find("input[type=checkbox]"));

    //loop through the boxes
    for(i = 0; i < _this.boxes.length; i++){
        current = _this.boxes[i];
        //attach the graphic html right after the actual input bux
        $(current).after('<div class="ui-checkbox" cbi="' + _this.setNum + '_' + i + '"></div>');

        //if the actual input box is already checked
        if($(current).is(':checked')){
            temp = $('.ui-checkbox[cbi=' + _this.setNum + '_' + i + ']');

            //make the graphic representation checked aswell
            $(temp).addClass('checked glyphicon glyphicon-ok');
        }


        //if a change is made to actual box (via labels)
         $(current).change(function(){
            who = $(this).next(".ui-checkbox");
            //if the actual input box is checked
            if($(this).is(":checked")){
                $(who).addClass('checked glyphicon glyphicon-ok');
            } else {
                $(who).removeClass('checked glyphicon glyphicon-ok');
            }

         });

         //hide the actual input box
         $(current).hide();
    }


    //on click of any graphic checkbox
     $(_this).find('.ui-checkbox').click(function(){
        var attr = $(this).attr('cbi');
        var index = attr.split("_");
        actualBox = _this.boxes[index[1]];
        //if the actual input box is checked
        if($(actualBox).is(":checked")){
            //uncheck the graphic
            $(this).removeClass('checked glyphicon glyphicon-ok');
            //uncheck the actual checkbox
            $(actualBox).prop("checked",false);

        } else {
            //check the graphic
            $(this).addClass('checked glyphicon glyphicon-ok');
            //check the actual
            $(actualBox).prop('checked',true);
        }
        $(actualBox).change();
     });


     setNum++;


  })
};
